import { DateTime } from 'luxon';

/** '20:00' → '8:00 PM'. */
export function fmtDueTime(hhmm: string): string {
  const [h, m] = hhmm.split(':').map(Number);
  return DateTime.fromObject({ hour: h ?? 0, minute: m ?? 0 }).toFormat('h:mm a');
}

export type ChoreUrgency = 'overdue' | 'soon' | 'ok';

/**
 * How pressing a timed chore is right now. `soon` is within 90 minutes of the deadline.
 * `dueOn` is YYYY-MM-DD (household-local); untimed chores are always `ok`.
 */
export function choreUrgency(
  dueOn: string,
  dueTime: string | null,
  zone: string,
  now: DateTime,
): ChoreUrgency {
  if (!dueTime) return 'ok';
  const [h, m] = dueTime.split(':').map(Number);
  const due = DateTime.fromISO(dueOn, { zone }).set({ hour: h ?? 0, minute: m ?? 0, second: 0 });
  if (now > due) return 'overdue';
  if (due.diff(now, 'minutes').minutes <= 90) return 'soon';
  return 'ok';
}

/** Sort key so timed chores lead (in time order) and untimed ones trail. */
export function choreSortKey(dueTime: string | null): string {
  return dueTime ?? '99:99';
}
